export default {
  infoBlockTitle: {
    id: 'bo_sellers-orders-drawers-export_csv_file-customer_receipts_info_text',
    defaultMessage:
      'Heads up: You can only export 6 months of orders at a time. Choose start and end dates that are 6 or less months apart.',
  },
} as const
